// extracted by mini-css-extract-plugin
export default {"bundleDetailsSelectedSubscription":"BundleDetails_bundleDetailsSelectedSubscription__BTcUh"};